<template>
	<div class="home">
		<div>
			<Navbar />
		</div>
		<div class="container">
			<div class="row">
				<div class="card rounded col col-md-8 col-lg-6 mx-auto my-4 px-0 shadow-lg mb-2">
					<div class="card-body p-0 rounded mw-auto">
						<div class="d-flex align-items-center p-3 mb-0">
							<div class="flex-shrink-0">
								<div class="rounded-image">
									<img src="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoHCBUSFRgVFRIYGBgaGBgYGBgYGBgYGBoZGBgZHBgYGBgcIS4lHB4rHxgYJjgmKy8xNTU1GiQ7QDszPy40NTEBDAwMEA8QGBISGDEhGCE0MTQ0NDQ0NDQ0NDQ0MTQ0NDQ0NDQ0MTE0NDQ0MTE0MTQ/NDQ/NDQ0MT80NDE0MTE0NP/AABEIAOEA4QMBIgACEQEDEQH/xAAcAAABBQEBAQAAAAAAAAAAAAAAAQIDBAUGBwj/xABFEAACAQIEAwYEAwQHBQkAAAABAgADEQQSITEFQVEGImFxgZETMqGxB2LBI0JSchSCktHh8PEkM3SishYXNUNjk6Oz0v/EABcBAQEBAQAAAAAAAAAAAAAAAAABAgP/xAAbEQEBAQEAAwEAAAAAAAAAAAAAARExAhJBIf/aAAwDAQACEQMRAD8A9dooQWJG5ksIQCEIQCEIQCNtreOhAIQhAIQhAIQhAIQiObA23gBYAgEi52HXyjKtZUVmY91QSx6BRczie1faVsPWAsoanlt3rAtVOUkgjvAJnOh0yljoNaGN7X0Ww5SiWqWp1MzspLL3WC577M7HvMdO8QOomj0kke+3jz09oGedUO3lBQmbOWVVQA5SS4VVPdUkjRnObmSB4DvqWLR1zKwIsG3GxFwY0TAxZWpYtGzG4yhVJa+neXN/0lT6yyJQRibmPjE3PnAkERtoQbaBR4q1qT+Updnl7i+Oss8ba1FvKR8AX9mnlA2IQhAbCETNAWISBvFMjdbwJAYRF2iwCETMIsAhCEAhCEAhCcr217ULg1+GmtZ1JXoinTO2vnYcyIG3xbiaYZC7eNluATboCbn0B8p5dxr8SKj3+CrU7WsMwJ03B0GnjY+k5nHcdcHO752cFWYnM9hpfvA6dLW+k5rHYsk5r5gTfNzudSG53mbWsaHEuK1KhZ3a7tck3/eN736mxkFLFMEALGzWOW+nMjQ+d/WUa1YPTAG+YD6Efa3tI8TiRfTYbelgPoBMjTTiD0yChswBsd9+evOb3D+2FTCsmuYA95SLh1JvlJ5ENcgjqw2JE4qnVubnYG58fD1kyVrm8n7B7p2A4vTr0nuwztVNR1JtbRFRAN2sFTbQ+4nd0GzKD1F/Q7fSfO/ZXj5wjtcuqNb4hphGfKNbAOLEdRcaEz3fs7xNcVh0qq6vdRcrprbZl1yt1XkbzfjdStSNTn5x0as0hwg20URKkDG7TPag0m4KtkT+UTP7ZPaiB1dR7mavCxZF8hCr8IQhCRbQlGtiiHyiBdIhGF7C9pA+JYH5DaBbtEiI9xeOgJaEIQCEIQCJeLCBQ41xRMJReu+yDQc2Y6Ko8SbCeFYzibYpmZ1LVWJJYDU9Fy3sFAAsOQ8hPS/xWxQXCpTv/vKg03JVO8T75fecz2F4J8TPWZbk5qaEi+VrAFumgBPoJm9WOIx3DSN0djYXswNvAWQD0mPU4fUykhGAuPnsOvjPofD9m6aqFy6Da+/mfEwr8Fp2tlHsI9V1831FCIvJiWJHTYD7H2lYUnYXCsR1AJE9/wAb2Ow1UjPTXTwlkdnqKiyooA2FokHzuysLLYjw2NzzMkZGX++09txnZOg75igvboOUpcQ7K03WwUaXtFlHk+HvzM9A/CztGMLifg1CFSsFS5JsrqWKHoLl2H9YdJxPF8A+HqFGvtp720kdIMx0OvIm0xyj6vMasyey2MFbC03BYjLlBe4chdAWvrfTfnoec1hOrJwiNFEa8Dl+2YJWkL/+Yk3uHjujyE5/te/foL1qD6AmdDgRp6SKtwhCEEx+L1PhlXtfXXymrTTKLXvIMfhBUWxlFChx+k2lzeadKurjTWcy+EWmSLWPlNXhR3kGktKxvJBFhKCESEAtCEIBCEIHA/inh1y0ahW5DMuboLBre4m32EoBcFT03zMfMsbmVvxJoZsIG/gqq3uGH6ibvA8KKOHpIP3UW/nYXk+r8W6psJm1nmizg6XmfWSEQoNY2qZLTTWMrrCs+oNbmVWaXK66aTPcEHWFjje3/D0akX/eBzD9RPO8M9iAdR0nsXafh3xsM9tWAJHp/hPGRoZjy6Pob8Ma+fAU77q7qdb7NfX0I+k60Tkvwuw3w+G0fzl36aM7W+gB9Z1s3OMlERooiNKOP7Um+Jwq/nY+yzqMHtOV7QG+Ow46K5+06vB7SKsQhCVDUN4+RUpJAp47DBxtK+HpkbTUMg+HY7aQJUJtrHGIBFgJCEIABCEIBCEBAweP1FrA4fKWPxKQfTQAsrajmCt9Rzv0NtfGkhDZgunzHl7yhXwijFrVLWLUxTC/xFHLgnrYZv7UuYmitQ5X1XpqL+okHlvG+MV8M5CYukbEizg3uNwTfxGkv8B7Z1K/dekpO2emwYHzB1EsdscA3w0w9JwqJcKMlzlP7rHZhoNdDpqTvMfspwB0dGCIgRVSyhwXygAO92IzHUki2+0NO+GKyrmItpznL8f7X/CByUi7che31nU8dSyWt+7rPMMfgXdtNiwzdQt9coOhPnpFQ1O1mNqH/d00Hi+s0+GcTrkjOoYcypuPSU+JcHSoAKCEIVQM712zgg98hV7m1yLZdTawAklLhjpWZqRy0r9xGfM6joWsL+tz4mSK7OkocW5MPvPCOL4f4daolvldxbyY2nt+Aci15wfaPgpbGu40GZHB/NYNFmj2Hs1gjh8Jh6R3Skgb+bKC31JmpOF/D/i2JxFWutV86IqkZtWDMzAWboQraeAndTUZKI0x0SBxvFRfH0/Cm31InV4P5ZyuIN8efCkv1P8AhOrwfyyLU0IsJUQ4Y3ElgBFgJFhEEBYl4xqgBteCOG2gPi3iWgYBCIIsAhCKIGFxBS+Mw5XUIHLjoHRgp95sV0vM+soStnZgMzIgHPkAB6maVQ2EDDxeGztqdJo4DCIg0Av15yljK9jYRrcXenVSl/RajIQt6q2OUnmyb2vuRfykVZ4smZSPCcwmCDNa2s2e0HGEoAnKWI0yqCzE9FUbmZOF4ktdQ3wnpvf5XADeN7EiCJF4WnNB5wfCKo0FpqJUFpSxNQawKQbLOZ7R12FbMvy5Rfz2v9JuYmtppOW4o5LEX5A26nxPSFd/+HdADDu9tXqnXwVVAHuW951swOxNA08FSB3Odv7TsR9LTflZETlHRh2MDjgL46qfyIP+qdbg/kE4zCPfF4g9GUew/wAZ2mE+RfKFqWEIQgiyOo9o9TAWV8Q5BFucsRpQXvApNh2bUyXC0ysskwUwFiRY1hAWLGII6AQhAwGPRViCyqSNVJAJB6g8pXxrkAgS4JSxQsD7ehgYC11zrc3ZibDyO5mzisQUUgKxNvT1nKvwR6tUMKrpY3BRrEeIuLTYxvBnKDNinZgNSwUg+NgBIrmsfVqO98pJXlb7R+G4gqg3TK/PT6x2L4azCxxNrdEP2vMirw9xcLiX12Jyi3pCrJ7REsVU7biK3FMy3mC3CPg941Gck3LMRc+g0jw9rE9YGtVqEjXnLrdkcQ7gZVKuFYPcdwFVzKw3JHhvMrgwOJxFOmvy5hfyGpP0nr0FqHCYZaSJTX5UUKPIC2smic4srJZG2xj2MZUPdPlA4XhRvXxDdan2UTucOLIvkJwnBh33PV2P1ne09h5D7SLToQhKgJErVcUAbDWPr0yZBhsLrcwLNNieUfmjpHk1vAa5MFe0ltI3TWAqVAY+RGjbURyGA+EWNMBYQiGAsjxA7p8pKIQMSm12vcX9Nv8AJjuIIWQi9tN72M5ntVUqYSt8RQcj3ObUi4XY8gbj2nF43tnVbuudNtL32/vk1cbfEOHVi+lZsvTNLFHBrTW9yTzJM5Kr2nJUBSb879Lc5mVe1FS5s2lv1EmxXRcV4iAwS+n2t/rMrEY4AGc4+NZiXLG+vtJsLTeqwvsNekmj1L8M0HxWY6tlY+Ww/WenTyv8PcStKtZjoVK/b+6epiaiUnOOiRZUIZBjqgRGJNu6ZPMntKhag4B6fcQOc4LTJY+d/qTO5AnI8KXK9uoA9xOuhaIQhCGVnsIqNpFZbxjU+hgPZwI1HvM7E18uhMtUXUDeBbiQBvCAsblizMx/aDC0HyVcQiOBfKT3rHwEDUiGcZxX8SMFQ7oLu38Ki3uTtOerfiqzE/CoIo3JqMSAOrG4Ak2Lj1S0jquqjM7BQObEAe5niGP/ABYxbXTDlSx/fNMZV/kU6nzb2nN1uJVKt8RiqrYhgbItRiyZ+ir8oA0JsANuslpj3vF9rMHTIX46szAlVp98kDdrjQKLfMSBylY9qFqBfhL89dKKMxtcFrO9uVgHt1IHIzxqlWanSNRzmq12BZiLnKhBt4C4UAdEImvhMd8N6NJm/cqubGxAqNZNtjkQMDyzxpj2jH4dKiFHQMp3B/zofGeXdp+xKKS9E6anIdD/AGuftOj4L2vD2o4ghalu6+yVB/F+Vuo26aWmhiyHvrL0eF4rh9RSVKEeoMpjh7toFnquP4OpJNhfylVODgbmT1VwuD4KRYufSbCUbCyiwmziMKFOglaol9AIkFfCVHDKtMEuzBUA5sTYD3nqHBe0Ka0We4TuK4uc+QBSbDU3IJFuonm9TFU+Hpndv29RP2ajVqdJgQXP8LsLqvRcx5icpieP1GuqdwdQe978vSPbB9EcI45QxV/hObi90dSjgBityjWYC45gbjqJqT5h4Fxp8JWWujEMDc6k5r7hut7n3nrHZj8UKWJqClXpiiWICPm7hY2AVr6rc7HUajaJ5Jj0UzM4+f2RHUj7zTmdxpMyAfmE0jKwFP8AaDzT/pE6aZGCp2f+sPoBNeAQhCAsS8JCjXdh0C/W8AxGFR/mW/uPtGLgEGwP9o/rLMAYDUQKLCOhOU7e9pTgKdO1s9R8t/4VAuxHidB7wF7X9rkwalUs1W23JfPx8J4Z2j4w9XFVKpPeuqjwKqqn/mBPrLnE8W9Sopckl318RmBP0nLAmo5PNjf1JmLdaWab6FmY+J3Nzy8SZDUqtU37qA6Dqep/ibxiVTnaw+VdB+Y8z6/a0t0KNtT/AKeUnBJgcIXIX5Qfe3MsenOSlhWqgLpTTuoPAHc+JJJPnHYip8OmbfNU7o8E/ePrt7yPCH4Yv0H1gapJxFdEUgKuVFPJVUEsx8AMzE+BkLYgVHesndGayDmqKoSmp8kVRI6dT4WHJ/fr5kU/w0lIFRvN27g8FfrIMA11deqH3GsDZocSVhZ9wQbbHzBl/h/bR6d0cFlGxuL+xnFJXMHa8uj06l24wdruW8shP2lHiHb2gdEpufEhVH3nnWWOFOT2o6DHdr6j6JTVfO7H9IvCMdUfPiK7k0KNiUBCCrVNzSw4I1OYgs29kRuovz9OgzMqqpZmYKijdmY2VR4kkCavaCqEZcLTYGnh7rcbVK5t8eqet3GVfyott4l+jPx2Kes71ajZndizN1J+wGwHIACQg2Fz6RVS++w1PlImbOeg5SBLkyQmwt7wRba9IynUscxFzfQfrA7zs129xuDCI7itTFu5UJzheiVNx4Zrjlpy9UwXanB41VFKuuc2PwnISqPAodTrzFx4z54epfffnJbpbv28jv8AWankY+m8OlmHmf1l2eLdi/xAOHIp4io1Wnsrs16iX0+Y/OvgTccidBPXeG8To4lc1GqtReeU6i+wZd1PgQJqVKuQhCVBIaQ77nxUey/4yYSDCtfOfzn6WECeAhCBk9puMrgcNUrsL5QAi/xOxyqvlci/gDPIO2+MfFUnzNmen8OqD1sCKlvDvXt0E6/8ay39CplT8uIRmH5crqCR0zMPeeY1OIgMHOqn5x1RhZh7EzNrUZhxedqR5CnUP9ZUb9QJnUTlVm5/KPNufteIndfLe9iwB6ggrf1BBggzFF6m8lF3CYcAA+0sqlzaSOttJC72BkEOIfO5PId1fIRrvYGNY2kNZ+6fI/aBp8ZutQUzb9lRo07Dk2QPV/8AkeofWQ8NbU+IP2ju0B/2rFf8RWHoKjAfQSvgHs4Hn9ovRADrJsnOVr94+cu0zpIG5feSpTsLtsJJRpk6yKsfiHKPlG8o1ODt8Cm+OOjgmhhR0qsvfqjrkQ6fndekxVp2E3eP0sj0sMNBh6Sq4/8AWq/tavqC6r/UlGigLa/KoLN5KLn7WijOxPdsnM6t+g9vvGKIwuXYsdySfeSEyBK7WUAbsY1F3a9gO6D5bmFb5ieSr9dh9TICS+g0Uf595Q41de7fz5/4RtupiZuS+8SwG5gSoR0nQdlOOVMDXWtTYkDR0Jsrod1P3B5HWc8DJaT2gfQ//eNgulX+wP8A9RJ4R/ST1hLpj6nlfBfL/WP3k7bHykGB+Qev3m2ViEJFiaopqznkCf7oHm/4nYhWcJe9kyOhOjI17+o3HiJ41VJpkoTcC+U9RO37WY9qjsxNzc3nEY6oH33Gxma0pO2oPS3sNv7vSWuHrer/ACgn/PvM9pf4Y/eY/lH3EWI1qplaoZcZb/5EqVJlVVzIavynyP2krS1wXCiviKdNvkZxn8Ka9+ofRFcxAvaI/wC14n/iK3v8Rr/W8p4Zu+ImMxRrVKlUixeo7kdC7FrfWMoN3xFDQe8fOaFBdJm095r4ZdBAlfRbDc6TT7N4VPi53F6dFWxFbxSkMwXxzPkW355mMdb9Jr8XP9FwyYbariMlfEdUpLrh6J6EkmoRuO7AyXqs5ao5u9Rmdz1ZyWb0uTBjlo1G5lQo8iReQh7m17Aak9AIzFV8yOOVgy+IvuPCBnU9o7PreRI2ka7wHVG7o6sdfQxp1HReXVjBtSo6CPyyojA/0EUeUUkCMvCn3j0MhvJKcgnzRYy0JB9bmR0FsoHh949jpEQaDyH2nVk6ct254uKNLID3mF/MA6idNWqBFLNsoJPkBPF+3fHxXqbHKu3eHhtp5yWrHIdoMUS5Oa4e58jsROcqvLeNr5j6ygzTPVRuZa4d83qP1lMmWuHHviW8R0TfL+spYgy47gKJm4h+6W8bCZVXdpo8JOSli63NaQor/NiGCk/+2tX3mSGvNXD0GfA1youRiKBIB7xSnSxBc5dyq5lJPK4lnSsa+kfROt/AyJm2klLYmBJhUuZuYSg1RlRFLMxCqo3JmTgVnQcK49/Q1rEUg71KeRHBs9MlgSy6dPqB4yBxelg6risyVKlHIyUlLNTqPmF0dxbRdyp3Fx4HDxPEHr1HrVGzO7FmY82P2HIDkABNDB8Po8QxFOjQ+ItSrUC3cghaapd3YW7zDKx3GgHnJe2/ZVuFVlpGstVXUspAysADYhkubeBvrrNWfgm7F4Q1cVT75RVdHd1tcAN3VW4tmJHPYKzfumX/AMV8fnx9SmECilSSmLAa3UVCx9XsPLxnH4THvRYujlWswDDcZlKkqeTZWYA7jMbSLF416ztUqOXdgAWNrkKoVb26KoHpJ8FVW0gTIwYoOsuIsUhqT6RzjxjlWwEjYnpMqYYRCI3LKhw85NTtIAJPSEVYsZYS58DwiTI+pavynyP2iYZrot+gjqmx8oqAW0nVlyfagYzE1RhMNlp0/hh61eorMO87KlNACLt3CTrtbwvxfGPw0rWJXFI5tsUZL+uYz1qrUA9JzvFsfJYseD8Y7LYrDk56RYfxJ3x9NfpOeqLbTae443FeM43juGpVb5kF/wCIaH3EmYrzuTYRrNJcdhQh0Nx47ysh1HnL2I18TV7okGMNkQdbmMqPcesTiDaIPyzE6tdhxDsOmGwmHxFXGBXrhWVcgKBWVWtmzd5gGB08ekrU3po+GpU6wqD4bg2tbO1SswQgE72T0InMVcZVekqPVdkT5EZyVX+VTtudusqU1O97W1m/xCMLG3Q29pOu0rrLdNLkCTyIuUDlW8TPeQVHubDYRQ2kyp1LEPTcOjsjqbqykqwPgR6xuOxdSs2erUd3sBmdixsNhc8pC7SNmiBGMbm1jWaNvNSIG3kmHW5jG3lrB0+f+bS3gsZZC8sOLSrUmFRNEimJKhRLFEayus3eyfD/AOk4qhStcPUQH+W92/5QZKr0n/sC/wDCYT16E1iIanymKvy+kITSM7F/KZyOP3MWELHM4rn6znOIc4sJFcfxTeUU3HmIQk8eJVptoY/93+UQhJOrUY+WFP5DCErKKnvL9Dc+UISeTUQLvJW2hCQQtGGEJYVE0bCE0gM1cD8nr+kISeQlqSm8ITKoGiLCEqFWdx+E/wD4lQ/r/wD1PFhH1X0RCEJtH//Z" />
								</div>
							</div>
							<div class="flex-column">
								<div class="flex-grow-1 ms-3 h4 mb-1">
									<b>Chanux Bro</b>
								</div>
								<div class="flex-grow-1 ms-3 h6">
									2 hours ago
								</div>
							</div>
						</div>


						<div class="mt-0 p-3 h5 mb-1 lh-base pt-1">
							<div v-if="this.post.type == 'text' || 'image'">
								{{ this.post.content }}
							</div>
						</div>

						<div v-if="this.post.type == 'image'">
							<div class="post-image">
								<img class="img-fluid" :src="'https://lux-we.essap.xyz/object/' + this.post.image" />
							</div>
						</div>
					</div>




				</div>
				<div class="container">
					<div class="row">
						<div class="col-md-4 d-flex offset-md-4 justify-content-center p-3">
							<div class="badge p-1">
								<a href="https://play.google.com/store/apps/details?id=com.chanuxbro"><img src="../../assets/images/google.png" class="img-fluid p-2 mt-3"/></a>
							</div>
							<div class="badge p-1">
								<a href="https://apps.apple.com/lk/app/chanux-bro/id1560152155"><img src="../../assets/images/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg" class="img-fluid p-2 mt-3"/></a>
							</div>
						</div>
				</div>
				</div>

			</div>

		</div>
	</div>
</template>


<script>
import Navbar from "../../components/Navbar";

export default {
	name: "Single",
	components: {
		Navbar,
	},

	data: () => ({
		post: {},
	}),

	mounted() {
		/**
		 * Fetch data from the origin API and store in the local
		 * data values for future usage.
		 */
		fetch("https://api.cbas.xyz/v1.0/post/" + this.$route.params.id)
			.then((Response) => Response.json())
			.then((Response) => {
				this.post = Response.data.post;
			});
	},
};
</script>

<style scoped>

/****Post content and images stylings******/

.post-image img{

	border-bottom-left-radius: 10px;
	border-bottom-right-radius: 10px;

}
.post {
	margin-top: 50px;
	border: 1px solid rgb(226, 218, 218);
	height: 500px;
	-webkit-box-shadow: 3px 3px 5px 1px #ccc;
	-moz-box-shadow: 3px 3px 5px 1px #ccc;
	box-shadow: 3px 3px 5px 1px #ccc;
	background-color: #c4c4c4;
}
.upper-row {
	padding: 50px;
	text-align: center;
	background: #ffff;
	border-radius: 10px;
}
.avatar img {
	width: 50px;
	height: 50px;
	border-radius: 100%;
	margin-right: 10px;
}
.post-author {
	font-size: 20px;
	text-align: left;
}
.post-timestamp {
	text-align: left;
	font-size: 10px;
	margin-bottom: 20px;
}
.description {
	text-align: left;
	font-size: 12px;
}

/**
* Card content CSS
*/
.rounded {
	border-radius: 10px !important;
}

.rounded-image img {
	border-radius: 100%;
	width: 50px;
	height: 50px;
}

.h6 {
	font-size: 8px;
}

.h4 {
	font-size: 16px;
}

.h5 {
	font-size: 13px;
}
.badge img{
	width: 500px;
	height: auto;
}


</style>
